import { MiniUsersResponseInterface } from "../users/users-response.interface";
import { CompanyResponseInterface } from "../companies/company-response.interface";
import { ProposalsResponseInterface } from "../proposals/proposals-response.interface";
import { AttachmentsResponseInterface } from "../attachments/attachments-response.interface";
import { Brand, Industry, ProductCategory } from "../../utils/enums.utils";

export interface MonitoringsResponseInterface {
  id: string;
  status: MonitoringStatus;
  category: string;
  monitoring_remarks: string | null;  
  buying_amount_vat_inc: number | null;
  selling_amount_vat_inc: number | null;
  estimated_gross_profit: number | null;
  mark_up: number | null;
  selling_amount_vat_ex: number | null;
  project_code: string | null;
  industry: Industry;
  product_category: ProductCategory;
  brand: Brand;
  project_name: string | null;
  created_at: string | null;
  updated_at: string | null;
  proposal: ProposalsResponseInterface;
  company: CompanyResponseInterface;
  created_by: MiniUsersResponseInterface | null;
  updated_by: MiniUsersResponseInterface | null;
  attachments: MonitoringAttachmentsResponseInterface[] | null;
}

export interface MonitoringAttachmentsResponseInterface {
  monitoring_id: string;
  attachment: AttachmentsResponseInterface;
  status: MonitoringAttachmentsStatus;
}

export enum MonitoringAttachmentsStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export enum MonitoringStatus {
  ACTIVE = 'Active',
  VERBALLY_WON = 'Verbally Won',
  WON = 'Won',
  LOST = 'Lost',
  DELETED = 'Deleted',
}